<template>
  <div>
    <!-- Check if Node is Empty -->
    <div v-if="node._id">
      <div :style="{ 'margin-left': `${depth * 30}px` }" class="node">
        <!-- &#9660 Down Pointing Arrow Icon -->
        <!-- &#9658 Right Pointing Arrow Icon -->
        <span
          style="position: absolute; z-index: 1;"
          @click="nodeClicked"
          v-if="haveChildren || hasID"
          >{{ expanded ? "&#9660;" : "&#9658;" }}</span
        >

        <span v-else>&#9671;</span>

        <!-- ********************** -->
        <!-- **** Display Name **** -->
        <!-- ********************** -->
        <div class="dropdown pl-4">
          <div class="fieldName pl-2" v-if="!editNameSwitch">
            <span class="nameStyle">'name'</span>: {{ node.name }},
          </div>
          <!-- Edit Name Option -->
          <div @keyup.enter="editNameField" v-if="editNameSwitch">
            <v-card flat class="pl-2">
              <input
                type="text"
                style="border: 1px solid black; padding-left: 5px;"
                :value="node.name"
                @input="updateData($event, node, 'name')"
              />
              <v-btn
                text
                small
                dark
                style="background-color: #ef5350; margin-bottom: 3px;"
                class="button ml-2"
                @click="editNameField"
                >Done</v-btn
              >
            </v-card>
          </div>

          <!-- Add Field Option  -->
          <div v-if="addFieldSwitch" class="addField-content input-group">
            <v-card flat>
              <div style="width: 100%; ">
                <div style="width: 200px; float: left;">
                  <div style="width: 100%; ">
                    <div style="width: 185px; float: left;">
                      <input
                        type="text"
                        placeholder="Field Name"
                        style="border: 1px solid black; padding-left: 5px;"
                      />
                    </div>
                    <div style="margin-left: 185px;">
                      <input
                        type="text"
                        placeholder="Field Value"
                        style="border: 1px solid black; padding-left: 5px;"
                      />
                    </div>
                  </div>
                </div>
                <div style="margin-left: 370px;">
                  <v-btn
                    text
                    small
                    dark
                    style="background-color: #ef5350;"
                    @click="addField"
                    >Done</v-btn
                  >
                </div>
              </div>
            </v-card>
          </div>
          <!-- Add Child Option -->
          <div v-if="addChildSwitch" class="addField-content input-group">
            <v-card flat>
              <div style="width: 100%;">
                <div style="width: 185px; float: left;">
                  <input
                    type="text"
                    placeholder="Child Name"
                    style="border: 1px solid black; padding-left: 5px;"
                  />
                </div>
                <div style="margin-left: 140px;">
                  <v-btn
                    text
                    small
                    dark
                    style="background-color: #ef5350;"
                    @click="addChild"
                    >Done</v-btn
                  >
                </div>
              </div>
            </v-card>
          </div>
          <!-- Remove Child Option -->
          <div v-if="removeChildSwitch" class="addField-content input-group">
            <v-card flat>
              <div style="width: 100%;">
                <div style="width: 185px; float: left;">
                  <input
                    type="text"
                    placeholder="Enter Child Name"
                    style="border: 1px solid black; padding-left: 5px;"
                  />
                </div>
                <div style="margin-left: 140px;">
                  <v-btn
                    text
                    small
                    dark
                    style="background-color: #ef5350;"
                    @click="removeChild"
                    >Done</v-btn
                  >
                </div>
              </div>
            </v-card>
          </div>

          <!-- **** Menu DropDown for Name Display **** -->
          <div v-if="menuExpandSwitch" class="dropdown-content">
            <v-btn-toggle>
              <v-btn text small class="button" @click="editNameField"
                >Edit Name</v-btn
              >
              <v-btn text small class="button" @click="addField"
                >Add Field</v-btn
              >
              <v-btn text small class="button" @click="addChild"
                >Add Child</v-btn
              >
              <v-btn text small class="button" @click="removeChild"
                >Remove Child</v-btn
              >
            </v-btn-toggle>
          </div>
        </div>

        <!-- *************************** -->
        <!-- **** Display Root Data **** -->
        <!-- *************************** -->
        <div v-if="expanded" style="margin-left: 30px;">
          <!-- ************************* -->
          <!-- **** Display Root ID **** -->
          <!-- ************************* -->
          <div v-if="root_id == node._id">
            <span class="nameStyle">'_id'</span>: {{ node._id }},
          </div>

          <!-- *************************** -->
          <!-- **** Display Parent ID **** -->
          <!-- *************************** -->
          <div v-if="root_id == node._id" class="pt-1">
            <div v-if="node.parent">
              <span class="nameStyle">'parent'</span>: {{ node.parent }},
            </div>
            <div v-else><span class="nameStyle">'parent'</span>: Null,</div>
          </div>

          <!-- ********************************** -->
          <!-- **** Display Root Child Count **** -->
          <!-- ********************************** -->
          <div v-if="root_id == node._id" class="pt-1">
            <span class="nameStyle">'child_count'</span>:
            {{ node.children.length }},
          </div>

          <!-- ************************************* -->
          <!-- **** Root Display Children Title **** -->
          <!-- ************************************* -->
          <div
            v-if="node.children.length >= 1 && root_id == node._id"
            class="pt-1 pb-1"
          >
            <span class="nameStyle">'children'</span>:
          </div>
        </div>

        <!-- ****************************************************** -->
        <!-- **** Display Everything else that's not Root Data **** -->
        <!-- ****************************************************** -->
        <div v-if="root_id != node._id" style="margin-left: 30px;">
          <div v-if="expanded">
            <!-- ******************** -->
            <!-- **** Display ID **** -->
            <!-- ******************** -->
            <span class="nameStyle">'_id'</span>: {{ node._id }},

            <!-- *************************** -->
            <!-- **** Display Parent ID **** -->
            <!-- *************************** -->
            <div class="pt-1">
              <span class="nameStyle">'parent'</span>: {{ node.parent }},
            </div>

            <!-- *********************** -->
            <!-- **** Display Value **** -->
            <!-- *********************** -->
            <div v-if="node.value" class="dropdown pt-1">
              <div class="fieldName">
                <span class="nameStyle">'value'</span>:
                <span class="valueStyle">{{ node.value }}</span
                >,
              </div>
              <!-- Edit Value Option -->
              <div
                @keyup.enter="editValue"
                v-if="editValueSwitch"
                class="addField-content input-group"
              >
                <v-card flat>
                  <div style="width: 100%;">
                    <div style="width: 185px; float: left;">
                      <!-- :value="node.value" @input="updateData($event, node, 'value')" -->
                      <input
                        placeholder="Enter Value"
                        style="border: 1px solid black; padding-left: 5px;"
                      />
                    </div>
                    <div style="margin-left: 140px;">
                      <v-btn
                        text
                        small
                        dark
                        style="background-color: #ef5350;"
                        class="button"
                        @click="editValue"
                      >
                        Done
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </div>
              <!-- Remove Value Option -->
              <div
                v-if="deleteCheckSwitch"
                class="addField-content input-group"
              >
                <v-card flat>
                  <div style="width: 100%; ">
                    <div style="width: 90px; float: left;">
                      <v-btn
                        text
                        small
                        dark
                        style="background-color: #ef5350;"
                        class="button"
                        @click="deleteCheck"
                      >
                        Remove
                      </v-btn>
                    </div>
                    <div style="margin-left: 90px;">
                      <v-btn
                        text
                        small
                        dark
                        style="background-color: grey;"
                        class="button"
                        @click="deleteCheck"
                        >Cancel</v-btn
                      >
                    </div>
                  </div>
                </v-card>
              </div>
              <!-- **** Menu DropDown **** -->
              <div v-if="menuExpandSwitch" class="dropdown-content">
                <v-btn-toggle>
                  <v-btn text small class="button" @click="editValue"
                    >Edit Value</v-btn
                  >
                  <v-btn text small class="button" @click="deleteCheck"
                    >Delete Value</v-btn
                  >
                </v-btn-toggle>
              </div>
            </div>

            <!-- ***************************** -->
            <!-- **** Display Child Count **** -->
            <!-- ***************************** -->
            <div>
              <span class="nameStyle">'child_count'</span>:
              {{ node.children.length }},
            </div>

            <!-- *************************** -->
            <!-- **** Display Meta Data **** -->
            <!-- *************************** -->
            <div v-if="node.meta" class="pt-1">
              <!-- **************************** -->
              <!-- **** Display Meta Title **** -->
              <!-- **************************** -->
              <div class="pb-1"><span class="nameStyle">'meta'</span>: {</div>

              <div style="margin-left: 20px;">
                <!-- *********************************** -->
                <!-- **** Display Meta Abbreviation **** -->
                <!-- *********************************** -->
                <div v-if="node.meta.abbrev" class="dropdown">
                  <div class="fieldName">
                    <span class="nameStyle">'abbrev'</span>:
                    <span class="valueStyle">{{ node.meta.abbrev }}</span
                    >,
                  </div>

                  <!-- Edit Abbreviation Option -->
                  <div
                    @keyup.enter="editAbbreviation"
                    v-if="editAbbreviationSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 185px; float: left;">
                          <input
                            type="text"
                            placeholder="Enter Value"
                            style="border: 1px solid black; padding-left: 5px;"
                            :value="node.meta.abbrev"
                            @input="updateData($event, node, 'meta.abbrev')"
                          />
                        </div>
                        <div style="margin-left: 140px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="editAbbreviation"
                          >
                            Done
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- Remove Abbreviation Option -->
                  <div
                    v-if="deleteAbbreviationSwitch"
                    class="addField-content input-group "
                  >
                    <v-card flat>
                      <div style="width: 100%; ">
                        <div style="width: 90px; float: left;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="deleteCheck"
                          >
                            Remove
                          </v-btn>
                        </div>
                        <div style="margin-left: 90px;">
                          <v-btn
                            small
                            dark
                            style="background-color: grey;"
                            class="button"
                            @click="deleteAbbreviationCheck"
                            >Cancel</v-btn
                          >
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- **** Menu DropDown **** -->
                  <div v-if="menuExpandSwitch" class="dropdown-content">
                    <v-btn-toggle>
                      <v-btn text small class="button" @click="editAbbreviation"
                        >Edit Abbrev</v-btn
                      >
                      <v-btn
                        text
                        small
                        class="button"
                        @click="deleteAbbreviationCheck"
                        >Delete Abbrev</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                </div>
                <div></div>

                <!-- *************************** -->
                <!-- **** Display Meta Type **** -->
                <!-- *************************** -->
                <div v-if="node.meta.type" class="dropdown">
                  <div class="fieldName">
                    <span class="nameStyle">'type'</span>:
                    <span class="valueStyle">{{ node.meta.type }}</span
                    >,
                  </div>
                  <!-- Edit Type Option -->
                  <div
                    @keyup.enter="editType"
                    v-if="editTypeSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 185px; float: left;">
                          <input
                            type="text"
                            placeholder="Enter Value"
                            style="border: 1px solid black; padding-left: 5px;"
                            :value="node.meta.type"
                            @input="updateData($event, node, 'meta.type')"
                          />
                        </div>
                        <div style="margin-left: 140px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="editType"
                          >
                            Done
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- Remove Type Option -->
                  <div
                    v-if="deleteTypeSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 90px; float: left;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="deleteTypeSwitchCheck"
                          >
                            Remove
                          </v-btn>
                        </div>
                        <div style="margin-left: 90px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: grey;"
                            class="button"
                            @click="deleteTypeSwitchCheck"
                            >Cancel</v-btn
                          >
                        </div>
                      </div>
                    </v-card>
                  </div>

                  <!-- **** Menu DropDown **** -->
                  <div v-if="menuExpandSwitch" class="dropdown-content">
                    <v-btn-toggle>
                      <v-btn text small class="button" @click="editType"
                        >Edit Type</v-btn
                      >
                      <v-btn
                        text
                        small
                        class="button"
                        @click="deleteTypeSwitchCheck"
                        >Delete Type</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                </div>
                <div></div>

                <!-- ******************************** -->
                <!-- **** Display Meta Precision **** -->
                <!-- ******************************** -->
                <div v-if="node.meta.precision >= 0" class="dropdown">
                  <div class="fieldName">
                    <span class="nameStyle">'precision'</span>:
                    <span class="valueStyle">{{ node.meta.precision }}</span
                    >,
                  </div>
                  <!-- Edit Precision Option -->
                  <div
                    @keyup.enter="editPrecision"
                    v-if="editPrecisionSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 185px; float: left;">
                          <input
                            type="number"
                            placeholder="Enter Value"
                            style="border: 1px solid black; padding-left: 5px;"
                            :value="node.meta.precision"
                            @input="updateData($event, node, 'meta.precision')"
                          />
                        </div>
                        <div style="margin-left: 140px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="editPrecision"
                          >
                            Done
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- Remove Value Option -->
                  <div
                    v-if="deletePrecisionSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 90px; float: left;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="deletePrecisionSwitchCheck"
                          >
                            Remove
                          </v-btn>
                        </div>
                        <div style="margin-left: 90px;">
                          <v-btn
                            small
                            dark
                            style="background-color: grey"
                            class="button"
                            @click="deletePrecisionSwitchCheck"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- **** Menu DropDown **** -->
                  <div v-if="menuExpandSwitch" class="dropdown-content">
                    <v-btn-toggle>
                      <v-btn text small class="button" @click="editPrecision"
                        >Edit Precision</v-btn
                      >
                      <v-btn
                        text
                        small
                        class="button"
                        @click="deletePrecisionSwitchCheck"
                        >Delete Precision</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                </div>
                <div></div>

                <!-- *********************************** -->
                <!-- **** Display Meta Display Hint **** -->
                <!-- *********************************** -->
                <div v-if="node.meta.display_hint" class="dropdown">
                  <div class="fieldName">
                    <span class="nameStyle">'display_hint'</span>:
                    <span class="valueStyle">{{ node.meta.display_hint }}</span
                    >,
                  </div>
                  <!-- Edit Display Hint Option -->
                  <div
                    v-if="editDisplayHintSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 185px; float: left;">
                          <input
                            type="text"
                            placeholder="Enter Value"
                            style="border: 1px solid black; padding-left: 5px;"
                            :value="node.meta.display_hint"
                          />
                        </div>
                        <div style="margin-left: 140px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="editDisplayHint"
                          >
                            Done
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- Remove Value Option -->
                  <div
                    v-if="deleteDisplayHintSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 90px; float: left;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="deleteDisplayHintCheck"
                          >
                            Remove
                          </v-btn>
                        </div>
                        <div style="margin-left: 90px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: grey"
                            class="button"
                            @click="deleteDisplayHintCheck"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- **** Menu DropDown **** -->
                  <div v-if="menuExpandSwitch" class="dropdown-content">
                    <v-btn-toggle>
                      <v-btn text small class="button" @click="editDisplayHint"
                        >Edit Hint</v-btn
                      >
                      <v-btn
                        text
                        small
                        class="button"
                        @click="deleteDisplayHintCheck"
                        >Delete Hint</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                </div>
                <div></div>

                <!-- ********************************* -->
                <!-- **** Display Meta Value Name **** -->
                <!-- ********************************* -->
                <div v-if="node.meta.value_name" class="dropdown">
                  <div class="fieldName">
                    <span class="nameStyle">'value_name'</span>:
                    <span class="valueStyle">{{ node.meta.value_name }}</span
                    >,
                  </div>

                  <!-- Edit Value Name Option -->
                  <div
                    v-if="editValueNameSwitch"
                    class="addField-content input-group pl-4"
                  >
                    <v-card flat>
                      <div style="width: 100%;" class="pl-5">
                        <div style="width: 185px; float: left;">
                          <input
                            type="text"
                            placeholder="Enter Value"
                            style="border: 1px solid black; padding-left: 5px;"
                            :value="node.meta.value_name"
                          />
                        </div>
                        <div style="margin-left: 140px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="editValueName"
                          >
                            Done
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- Remove Value Option -->
                  <div
                    v-if="deleteValueNameSwitch"
                    class="addField-content input-group pl-1"
                  >
                    <v-card flat>
                      <div style="width: 100%;" class="pl-5">
                        <div style="width: 90px; float: left;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="deleteValueNameSwitchCheck"
                          >
                            Remove
                          </v-btn>
                        </div>
                        <div style="margin-left: 90px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: grey"
                            class="button"
                            @click="deleteValueNameSwitchCheck"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- **** Menu DropDown **** -->
                  <div v-if="menuExpandSwitch" class="dropdown-content pl-9">
                    <v-btn-toggle>
                      <v-btn text small class="button" @click="editValueName"
                        >Edit Value Name</v-btn
                      >
                      <v-btn
                        text
                        small
                        class="button"
                        @click="deleteValueNameSwitchCheck"
                        >Delete Value</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                </div>
                <div></div>

                <!-- ******************************** -->
                <!-- **** Display Meta Data: uom **** -->
                <!-- ******************************** -->
                <div
                  @keyup.enter="editUom"
                  v-if="node.meta.uom"
                  class="dropdown"
                >
                  <div class="fieldName">
                    <span class="nameStyle">'uom'</span>:
                    <span class="valueStyle">{{ node.meta.uom }}</span
                    >,
                  </div>

                  <!-- Edit uom Option -->
                  <div
                    v-if="editUomSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 185px; float: left;">
                          <input
                            type="text"
                            placeholder="Enter Value"
                            style="border: 1px solid black; padding-left: 5px;"
                            :value="node.meta.uom"
                            @input="updateData($event, node, 'meta.uom')"
                          />
                        </div>
                        <div style="margin-left: 140px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="editUom"
                          >
                            Done
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- Remove uom Option -->
                  <div
                    v-if="deleteUomSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;">
                        <div style="width: 90px; float: left;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="deleteUomSwitchCheck"
                          >
                            Remove
                          </v-btn>
                        </div>
                        <div style="margin-left: 90px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: grey"
                            class="button"
                            @click="deleteUomSwitchCheck"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- **** Menu DropDown **** -->
                  <div v-if="menuExpandSwitch" class="dropdown-content">
                    <v-btn-toggle>
                      <v-btn text small class="button" @click="editUom"
                        >Edit uom</v-btn
                      >
                      <v-btn
                        text
                        small
                        class="button"
                        @click="deleteUomSwitchCheck"
                        >Delete uom</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                </div>
                <div></div>

                <!-- ************************************* -->
                <!-- **** Display Meta Data: Long uom **** -->
                <!-- ************************************* -->
                <div
                  @keyup.enter="editUomLong"
                  v-if="node.meta.uom_long"
                  class="dropdown"
                >
                  <div class="fieldName">
                    <span class="nameStyle">'uom_long'</span>:
                    <span class="valueStyle">{{ node.meta.uom_long }}</span
                    >,
                  </div>

                  <!-- Edit uom_Long Option -->
                  <div
                    v-if="editUomLongSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;" class="pl-5">
                        <div style="width: 190px; float: left;">
                          <input
                            type="text"
                            placeholder="Enter Value"
                            style="border: 1px solid black; padding-left: 5px; padding-right: 5px;"
                            :value="node.meta.uom_long"
                            @input="updateData($event, node, 'meta.uom_long')"
                          />
                        </div>
                        <div style="margin-left: 140px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="editUomLong"
                          >
                            Done
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- Remove Value Option -->
                  <div
                    v-if="deleteUomLongSwitch"
                    class="addField-content input-group"
                  >
                    <v-card flat>
                      <div style="width: 100%;" class="pl-5">
                        <div style="width: 90px; float: left;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: #ef5350;"
                            class="button"
                            @click="deleteUomSwitchLongCheck"
                          >
                            Remove
                          </v-btn>
                        </div>
                        <div style="margin-left: 90px;">
                          <v-btn
                            text
                            small
                            dark
                            style="background-color: grey"
                            class="button"
                            @click="deleteUomSwitchLongCheck"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <!-- **** Menu DropDown **** -->

                  <div v-if="menuExpandSwitch" class="dropdown-content pl-5">
                    <v-btn-toggle>
                      <v-btn text small class="button" @click="editUomLong"
                        >Edit uom Long</v-btn
                      >
                      <v-btn
                        text
                        small
                        class="button"
                        @click="deleteUomSwitchLongCheck"
                        >Delete uom Long</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                </div>
              </div>
              <!-- Closing Bracket for Meta Data -->
              },
            </div>

            <!-- ******************************** -->
            <!-- **** Display Children Title **** -->
            <!-- ******************************** -->
            <div v-if="node.children.length >= 1" class="pb-1">
              <span class="nameStyle">'children'</span>:
            </div>
          </div>
        </div>
      </div>

      <!-- ******************************* -->
      <!-- **** Recursive Call        **** -->
      <!-- **** Loop through Children **** -->
      <!-- ******************************* -->
      <div v-if="expanded">
        <DisplayTree
          v-for="child in node.children"
          :key="child._id"
          :node="child"
          :depth="depth + 1"
        />
      </div>
    </div>

    <!-- ******************************************************* -->
    <!-- **** If Node is Please Wait if Display Unavailable **** -->
    <!-- ******************************************************* -->
    <div v-else>
      Please Wait...
    </div>
  </div>
</template>

<script>
export default {
  name: "DisplayTree",
  props: {
    node: Object,
    root_id: String,
    depth: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      offset: true,
      root: "",
      expanded: false,
      menuExpandSwitch: true,
      editNameSwitch: false,
      addFieldSwitch: false,
      addChildSwitch: false,
      removeChildSwitch: false,
      editValueSwitch: false,
      deleteCheckSwitch: false,
      editAbbreviationSwitch: false,
      deleteAbbreviationSwitch: false,
      editPrecisionSwitch: false,
      deletePrecisionSwitch: false,
      editValueNameSwitch: false,
      deleteValueNameSwitch: false,
      editUomSwitch: false,
      deleteUomSwitch: false,
      editDisplayHintSwitch: false,
      deleteDisplayHintSwitch: false,
      editUomLongSwitch: false,
      deleteUomLongSwitch: false,
      editTypeSwitch: false,
      deleteTypeSwitch: false,
      addMetaSwitch: false
    };
  },
  methods: {
    updateData(e, node, field) {
      if (!node || !e.currentTarget || !e.currentTarget.value) {
        return;
      }
      this.$store.dispatch("updatePatientData", {
        node: node,
        field: field,
        value: e.currentTarget.value,
        oldValue: e.currentTarget._value
      });
    },
    getRootId() {
      return this.root_id;
    },
    menuExpand() {
      this.menuExpandSwitch = !this.menuExpandSwitch;
    },
    // Switch for this.expanded
    nodeClicked() {
      this.expanded = !this.expanded;
    },
    // Switch for this.editNameSwitch
    editNameField() {
      this.editNameSwitch = !this.editNameSwitch;
      this.menuExpand();
    },
    // Switch for this.addFieldSwitch
    addField() {
      this.addFieldSwitch = !this.addFieldSwitch;
      this.menuExpand();
    },
    // Switch for this.addChildSwitch
    addChild() {
      this.addChildSwitch = !this.addChildSwitch;
      this.menuExpand();
    },
    // Switch for this.addChildSwitch
    removeChild() {
      this.removeChildSwitch = !this.removeChildSwitch;
      this.menuExpand();
    },
    // Switch for this.editValueSwitch
    editValue() {
      this.editValueSwitch = !this.editValueSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteCheckSwitch
    deleteCheck() {
      this.deleteCheckSwitch = !this.deleteCheckSwitch;
      this.menuExpand();
    },
    // Switch for editAbbreviationSwitch
    editAbbreviation() {
      this.editAbbreviationSwitch = !this.editAbbreviationSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteAbbreviationSwitch
    deleteAbbreviationCheck() {
      this.deleteAbbreviationSwitch = !this.deleteAbbreviationSwitch;
      this.menuExpand();
    },
    // Switch for this.editPrecisionSwitch
    editPrecision() {
      this.editPrecisionSwitch = !this.editPrecisionSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteAbbreviationSwitch
    deletePrecisionSwitchCheck() {
      this.deletePrecisionSwitch = !this.deletePrecisionSwitch;
      this.menuExpand();
    },
    // Switch for this.editValueNameSwitch *
    editValueName() {
      this.editValueNameSwitch = !this.editValueNameSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteValueNameSwitch
    deleteValueNameSwitchCheck() {
      this.deleteValueNameSwitch = !this.deleteValueNameSwitch;
      this.menuExpand();
    },
    // Switch for this.editUomSwitch
    editUom() {
      this.editUomSwitch = !this.editUomSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteUomSwitch
    deleteUomSwitchCheck() {
      this.deleteUomSwitch = !this.deleteUomSwitch;
      this.menuExpand();
    },
    // Switch for this.editDisplayHintSwitch
    editDisplayHint() {
      this.editDisplayHintSwitch = !this.editDisplayHintSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteDisplayHintSwitch
    deleteDisplayHintCheck() {
      this.deleteDisplayHintSwitch = !this.deleteDisplayHintSwitch;
      this.menuExpand();
    },
    // Switch for this.editUomLongSwitch
    editUomLong() {
      this.editUomLongSwitch = !this.editUomLongSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteUomLongSwitch
    deleteUomSwitchLongCheck() {
      this.deleteUomLongSwitch = !this.deleteUomLongSwitch;
      this.menuExpand();
    },
    // Switch for this.editTypeSwitch
    editType() {
      this.editTypeSwitch = !this.editTypeSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteTypeSwitch
    deleteTypeSwitchCheck() {
      this.deleteTypeSwitch = !this.deleteTypeSwitch;
      this.menuExpand();
    },
    addMeta() {
      this.addMetaSwitch = !this.addMetaSwitch;
      this.menuExpand();
    }
  },
  computed: {
    // Check for Children
    haveChildren() {
      return this.node.children;
    },
    // Checks for ID to create drop down
    hasID() {
      return this.node._id;
    }
  }
};
</script>

<style scoped>
/* Buttons for Drop Menus */
.fieldName {
  float: left;
  padding-right: 150px;
}

/* Wrap around where you what hover effects */
.dropdown {
  display: inline-block;
}

/* Wrap around menu items */
.dropdown-content {
  margin-bottom: 10px;
  display: none;
  z-index: 1;
}

/* Drop menu on hover */
.dropdown:hover .dropdown-content {
  position: absolute;
  right: 0;
  width: 35%;
  display: block;
}

.addField-content {
  position: absolute;
  right: 0;
  width: 35%;
  display: inline-block;
}

/* Basic Styling for everything */
.node {
  text-align: left;
  font-size: 17px;
}

/* Styling for field names */
.nameStyle {
  color: #0066ff;
}

/* Styling for field values */
.valueStyle {
  color: #505050;
}
</style>
